import React, { useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { Switch, FormControlLabel } from '@material-ui/core'
import HeaderApp from '../../../../LaridaeApp/components/HeaderApp'
import CamposPesado0 from '../../../components/pesado/CamposPesado0'
import { getNumericValidator } from '../../../../Forms/fieldValidators'

const numeric12 = getNumericValidator(9, 12)

function PesadoBrutoChoferLectura (props) {
  const { submitNumero, onBlurInput, mode = 'dark' } = props
  const validate = [numeric12]

  useEffect(() => {
    onBlurInput()
  }, [onBlurInput])

  return (
    <div style={{ height: '100vh' }} className={`container-lectura-bruto-${mode}`}>
      <div className='App-header-panel'>
        <HeaderApp hideButton />
      </div>
      <div>
        <FormControlLabel
          control={<Switch
            color='default'
            name='mode'
            onChange={props.updateTheme}
            checked={mode === 'dark'}
          />
          }
          label='Modo oscuro'
          style={{ float: 'right' }}
        />

        <div className='contenedor-pesado-chofer'>
          <h1 style={{ fontSize: '3rem' }} className={`text-lectura-peso-bruto-${mode}`}>Sr.Transportista por favor verifique el peso bruto de su carga</h1>
          <h2
            style={{
              fontSize: '2.3rem',
              width: '80%',
              margin: 0
            }}
            className={`text-lectura-peso-bruto-${mode}`}
          >
            Escanee el código QR en la parte inferior del panel para confirmar el peso bruto
          </h2>
          {/* { (pesoCabezal > 0 && modo === 'auto')
            ? <h1 className='peso-cabezal-chofer'>{pesoCabezal}<span style={{ fontSize: '2rem' }}>Kgs.</span></h1>
            : <></>
          } */}
        </div>
        <div className='campos-cea-destare' >
          <form onSubmit={submitNumero} style={{ opacity: 0, position: 'absolute' }} >
            <CamposPesado0
              label=''
              validate={validate}
              disabled={false}
              onBlurInput={onBlurInput}
            />
            <Button
              className='btn-pesado-destare'
              type='submit'
              size='lg'
            >Siguiente</Button>
          </form>
        </div>
      </div>

    </div>
  )
}

export default PesadoBrutoChoferLectura
